import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";

//API
import api from "../../api/api";

//UI
import { Card } from "../ui/card";

//Components
import Spinner from "../layout/Spinner";
import Post from "../feed/Post";
import StandalonePostError from "./StandalonePostError";

//Actions
import { getPostData } from "../../actions/feed";

//Selectors
import { getPostDataFromCache, isPostDataCached } from "../../selectors/postSelectors";

const StandalonePost = ({ getPostData, feed }) => {
  const { postID, username } = useParams();

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const dispatchedRef = useRef(false);

  // Resolve from cache when available
  useEffect(() => {
    const cachedData = getPostDataFromCache(feed, postID);
    if (cachedData) {
      setPost({
        blockRepost: cachedData.blockRepost,
        postData: cachedData,
        postid: postID,
      });
      setError(false);
      setLoading(false);
      return;
    }

    // If not cached (or expired), attempt lazy fetch via action which also populates cache
    const errorCooldown = feed?.postCache?.errors?.[postID];
    const inCooldown = errorCooldown && errorCooldown > Date.now();

    if (!inCooldown && !dispatchedRef.current) {
      dispatchedRef.current = true;
      // index -1 ensures no feed list mutation while still caching in reducer
      getPostData(postID, -1);
      setLoading(true);
    }

    // If in error cooldown and still no cache, show error
    if (inCooldown && !cachedData) {
      setError(true);
      setLoading(false);
    }
  }, [feed, postID, getPostData]);
  return (
    <div className="w-full py-[4rem] md:pl-[5rem] md:py-0 bg-background md:bg-neutral-50 min-h-screen">
      {loading ? (
        <Spinner />
      ) : error ? (
        <StandalonePostError />
      ) : (
        <div className="max-w-[600px] m-auto py-8 [max-width:600px]:border-separator [max-width:600px]:border [max-width:600px]:rounded-lg">
          <Post post={post} />
        </div>
      )}
    </div>
  );
};

StandalonePost.propTypes = {
  getPostData: PropTypes.func.isRequired,
  feed: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  feed: state.feed,
});

export default connect(mapStateToProps, { getPostData })(StandalonePost);
